<template>
    <div class="container-fluid">
        <div class="row swiper-1row d-md-none mb-1 mt-2 text-center">
            <h2 class="mx-1">
                {{ title }}
            </h2>
            <div class="col-12">
                <div class="ob1-carrousel equipment-band-swiper-container">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(equipmentBand, equipmentBandIndex) in equipmentsBand"
                            :key="equipmentBandIndex"
                            class="swiper-slide"
                        >
                            <a
                                v-if="equipmentBand"
                                class="equipment-band"
                                :href="equipmentBand.url"
                                :data-oevent-category="equipmentBand.tms.tagZone"
                                :data-oevent-action="equipmentBand.tms.tagName"
                                :data-oevent-label="equipmentBand.url"
                            >
                                <div
                                    class="forward-first-card"
                                    :class="equipmentBand.forwardFirst ? 'bg-greige' : 'bg-white'"
                                />
                                <img
                                    :src="equipmentBand.image.src"
                                    :alt="equipmentBand.image.alt"
                                    class="equipment-band-image-swiper"
                                >
                                <h3 class="lead p-0 m-0 pt-2 fw-bold title">
                                    {{ equipmentBand.title }}</h3>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-none d-md-block mb-1 mt-2">
            <h2>{{ title }}</h2>
            <div v-for="y in numberOfRows(4)" :key="y" class="row text-center">
                <div v-for="x in 4" :key="x" class="col-3">
                    <a
                        v-if="equipmentsBand[index(x, y, 4)]"
                        class="equipment-band"
                        :href="equipmentsBand[index(x, y, 4)].url"
                        :data-oevent-category="equipmentsBand[index(x, y, 4)].tms.tagZone"
                        :data-oevent-action="equipmentsBand[index(x, y, 4)].tms.tagName"
                        :data-oevent-label="equipmentsBand[index(x, y, 4)].url"
                    >
                        <div
                            class="forward-first-card"
                            :class="equipmentsBand[index(x, y, 4)].forwardFirst ? 'bg-greige' : 'bg-white'"
                        />
                        <img
                            :src="equipmentsBand[index(x, y, 4)].image.src"
                            class="equipment-band-image"
                            :alt="equipmentsBand[index(x, y, 4)].image.alt"
                        >
                        <h3 class="lead p-0 m-0 pt-2 fw-bold title">
                            {{ equipmentsBand[index(x, y, 4)].title }}</h3>
                    </a>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center mb-1 mb-md-2">
            <ob1-liens
                :text="labelButton"
                :href="urlButton"
                with-arrow
                data-oevent-category="marchand_eqpt"
                data-oevent-action="voir-tous-les-mobiles"
                :data-oevent-label="urlButton"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        equipmentsBand: {
            type: Array,
            required: true
        },
        labelButton: {
            type: String,
            required: true
        },
        urlButton:{
            type: String,
            required: true
        }
    },
    mounted: function () {
        const equipmentBandSwiper = new Swiper(".equipment-band-swiper-container", {
            slidesPerView: "auto",
            spaceBetween: 0,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initialSlide: 0,
        });
    },
    methods: {
        numberOfRows(col) {
            return Math.trunc((this.equipmentsBand.length - 1) / col) + 1;
        },
        index(x, y, col) {
            return (x - 1) + (y - 1) * col;
        },
    },
}
</script>
<style scoped lang="scss">
@import 'ob1_variables';

.bottom-0 {
    bottom: 0;
}

.equipment-band-image {
    @media(min-width: #{map-get($grid-breakpoints, md)}) {
        height: 55%;
    }
    @media(min-width: #{map-get($grid-breakpoints, xl)}) {
        height: 80%;
    }
}

.equipment-band {
    display: block;
    height: 100%;
    padding: 0 45px 45px;
    @media(min-width: #{map-get($grid-breakpoints, md)}) {
        padding: 0;
    }
    position: relative;
    text-align: center;
}

.forward-first-card {
    border-radius: 12px;
    bottom: 5px;
    @media(min-width: #{map-get($grid-breakpoints, xl)}) {
        bottom: 0;
    }
    box-shadow: 0 4px 4px 0 #ddd6;
    @media(min-width: #{map-get($grid-breakpoints, md)}) and (max-width: #{map-get($grid-breakpoints, xl)}) {
        bottom: 45px;
        left: 0;
        right: 0;
    }
    left: 20px;
    position: absolute;
    right: 20px;
    top: 37%;
}

.equipment-band img {
    display: block;
    margin: 0 auto;
    position: relative;
}

.equipment-band .title {
    position: relative;
}

.equipment-band-swiper-container .swiper-slide {
    width: 240px;
}

.equipment-band-image-swiper {
    height: 234px;
}

</style>
